import { Checkbox, TextInput } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { PathProxy } from "../../../../../utils/forms-proxy"
import { RemoteMultiSelect } from "../../../../../-components/remote-multi-select"
import { TheaModuleMultiSelect } from "../../../../../blocks/module-multi-select"
import { AbsentApprovalConfig } from "../../../../../@client/Theasoft_Absences_Config"
import { AbsenceUserWithEmailInfoSelect } from "../../../../../-components/AbsenceUserWithEmailInfoSelect"
import { userSelectRenderOptionWithEmailAddressWarning } from "../../../../../-components/userSelectRenderOptionWithEmailAddressWarning"
import { useTranslations } from "../../../../../utils/use-t"
import { ContractTypeOrCategorySelect } from "./contract-type-or-category-tree-select"

type Props = {
  f: UseFormReturnType<AbsentApprovalConfig>
  _: PathProxy<AbsentApprovalConfig, AbsentApprovalConfig>
}

export function AbsenceConfigFormInputs({ f, _ }: Props) {
  const {
    appServer: { t },
    absences: { t: tAbsences },
  } = useTranslations()
  return (
    <>
      <TextInput
        label="Name"
        placeholder={t("ConfigurationName")}
        {...f.getInputProps(_.name._PATH_)}
      />
      <AbsenceUserWithEmailInfoSelect
        renderOption={userSelectRenderOptionWithEmailAddressWarning}
        label="Admins"
        description={t("AbsenceAdminInputDescription")}
        placeholder="Admins"
        {...f.getInputProps(_.admins._PATH_)}
      />
      <RemoteMultiSelect<"/api/Absence/GetAllShiftTypes", number>
        url="/api/Absence/GetAllShiftTypes"
        label={tAbsences("ReasonsOrShiftTypes")}
        placeholder={tAbsences("ReasonsOrShiftTypes")}
        map={(value) => ({
          value: value.shiftTypeId.toString(),
          label: value.name,
        })}
        toValue={(value) => parseInt(value)}
        fromValue={(value) => value?.toString()}
        {...f.getInputProps(_.reasons._PATH_)}
      />
      <TheaModuleMultiSelect
        label={t("ModuleAssignments")}
        description={t("ModuleAssignmentsDescription")}
        placeholder={t("ModuleAssignmentsPlaceholder")}
        {...f.getInputProps(_.modules._PATH_)}
      />
      <ContractTypeOrCategorySelect
        label={`${t("AvailableFor")} ${t("Contracttypes")}`}
        initialCheckedState={f.values.availableToContractTypes}
        onCheckedStateChange={(v) => {
          f.setFieldValue(_.availableToContractTypes._PATH_, v)
        }}
      />
      <Checkbox
        label={t("ShowTimeAccountInfo")}
        {...f.getInputProps(_.timeAccountInfo.enabled._PATH_, {
          type: "checkbox",
        })}
      />
    </>
  )
}
